var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.333 13.3333H18.6665L26.6665 104L63.9998 114.667L101.333 104L109.333 13.3333Z",
    fill: "#E65100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 21.3333V106.4L93.8667 97.8666L100.533 21.3333H64Z",
    fill: "#FF6D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66.6667V56.0001H86.9333L85.0667 86.6667L64 93.6001V82.4001L74.9333 78.6667L75.7333 66.6667H64ZM87.7333 45.3334L88.5333 34.6667H64V45.3334H87.7333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0001 82.4001V93.6001L42.9334 86.6667L41.8667 72.0001H52.5334L53.0667 78.6667L64.0001 82.4001ZM50.9334 45.3334H64.0001V34.6667H39.7334L41.6001 66.6667H64.0001V56.0001H51.7334L50.9334 45.3334Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.0b9d3fd3a872d418b02ad6708206ca6f.svg";
export { ForwardRef as ReactComponent };